import { IMarketFeedResponse } from "@finbackoffice/clientbff-client";
import { moveMarketToFirstByIndex } from "@finbackoffice/site-core";
import { useMemo } from "react";

export type IGroupedAndSortedMainMarketsOpenedState = {
    left: boolean;
    right: boolean;
};

export const useSortedFeaturedMarkets = (
    totalMarkets: IMarketFeedResponse[],
    handicapMarkets: IMarketFeedResponse[],
) => {
    const sortedTotalMarkets = useMemo(() => {
        if (totalMarkets.length > 1) {
            if (totalMarkets.length <= 3) {
                return moveMarketToFirstByIndex(totalMarkets, 1);
            } else if (totalMarkets.length <= 7) {
                return moveMarketToFirstByIndex(totalMarkets, 2);
            } else {
                return moveMarketToFirstByIndex(totalMarkets, 3);
            }
        }
        return totalMarkets;
    }, [totalMarkets]);

    const sortedHandicapMarkets = useMemo(() => {
        if (handicapMarkets.length > 1) {
            if (handicapMarkets.length <= 3) {
                return moveMarketToFirstByIndex(handicapMarkets, 1);
            } else if (handicapMarkets.length <= 7) {
                return moveMarketToFirstByIndex(handicapMarkets, 2);
            } else {
                return moveMarketToFirstByIndex(handicapMarkets, 3);
            }
        }
        return handicapMarkets;
    }, [handicapMarkets]);

    return { sortedTotalMarkets, sortedHandicapMarkets };
};
